"use client";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="shell">
      <section className="panel" role="alert" aria-labelledby="error-title">
        <p className="eyebrow">Uygulama hatası</p>
        <h1 id="error-title">Bir şeyler ters gitti.</h1>
        <p>İstek tamamlanamadı. Lütfen yeniden deneyin.</p>
        {error.digest ? <p>Hata referansı: {error.digest}</p> : null}
        <button className="health-link" type="button" onClick={reset}>
          Yeniden dene
        </button>
      </section>
    </main>
  );
}
